// utils/priceConverter.js

/**
 * Converts a cryptocurrency amount to USD
 * @param {string|number} cryptoAmount - Amount in cryptocurrency
 * @param {string|number} cryptoPrice - Current price of crypto in USD
 * @returns {string} Formatted USD amount with 2 decimals
 */
export const convertCryptoToUSD = (cryptoAmount, cryptoPrice) => {
    if (!cryptoAmount || !cryptoPrice) return "0.00";

    const amount = parseFloat(cryptoAmount);
    const price = parseFloat(cryptoPrice);

    if (isNaN(amount) || isNaN(price)) return "0.00";

    return (amount * price).toFixed(2);
};